import React, { useState } from 'react';
import ItemGroup from './ItemGroup';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ChartLine from './ChartLine';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';

function SG3KPI_CONSOLIDATE_MONTH_DUMMY(props) {
    const { t } = useTranslation();

    const { 
        inputParam_TwoColumnsDisplay = false,
    } = props;
    const [consolidatedGroupDataSeries, setConsolidatedGroupDataSeries] = useState(JSON.parse(JSON.stringify(__OBJECT_STRUCTURE_GetList(999999, null))))
    
    const [objBoardScopeValues, setObjBoardScopeValues] = useState([{
            boardId:0,
            color:'v',
            deactivate:null,
            hasDataseries:true,
            id:-1,
            name:'Eficiencia',
            perspectiveCode:'R',
            perspectiveId:null,
            scopeCode:'SCP1',
            scopeNemo:null,
            scopeValue:79.0893525,
            visible:false
        },{
            boardId:0,
            color:'a',
            deactivate:null,
            hasDataseries:true,
            id:-2,
            name:'Seguridad',
            perspectiveCode:'D',
            perspectiveId:null,
            scopeCode:'SCP2',
            scopeNemo:null,
            scopeValue:59.0893525,
            visible:false
        }
    ]);

    const [consolidatedGroupChart, setConsolidatedGroupChart] = useState([{
        name: 'Eficiencia',
		l_vals: [
            {
                color: 'v',
                periodId: 202301,
                scopeValue: 96.6666675
            },
            {
                color: 'r',
                periodId: 202302,
                scopeValue: 65.75
            },
            {
                color: 'a',
                periodId: 202303,
                scopeValue: 71.5
            }
        ]
    }]);
    
    const generateDom = () => {
		return  <Row style={{opacity: ".4" }}>
                    {
                        inputParam_TwoColumnsDisplay &&
                        <Col className='pe-0'>
                            <Row className='px-3'>
                                {
                                    objBoardScopeValues.map((item, index) => 
                                        <div key={index}>
                                            <Row className='p-0'>
                                                <Col className='mx-0 pb-2 px-1 mx-auto'>
                                                    <ItemGroup 
                                                        inputParam_Key={ index }
                                                        inputParam_Object={item}
                                                        inputParam_ElementId={null}
                                                        inputParam_HasPageElementId={false}
                                                        inputParam_ConsolidatedGroupDataSeries={null}
                                                        inputParam_SetConsolidatedGroupDataSeries={null}
                                                        inputParam_SetterSelectedElementToPanel={null}
                                                        inputParam_ShowToolbar={false}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    )
                                }
                            </Row>
                        </Col>
                    }
                    {
                        !inputParam_TwoColumnsDisplay &&
                        <Col xl={12} className='pe-0'>
                            <Row className='px-3'>
                                <div>
                                    <Row className='p-0'>
                                    {
                                        objBoardScopeValues.map((item, index) => 
                                            <Col key={index} xl={6} className='mx-0 pb-2 px-1 mx-auto'>
                                                <ItemGroup 
                                                    inputParam_Key={ index }
                                                    inputParam_Object={item}
                                                    inputParam_ElementId={null}
                                                    inputParam_HasPageElementId={false}
                                                    inputParam_ConsolidatedGroupDataSeries={null}
                                                    inputParam_SetConsolidatedGroupDataSeries={null}
                                                    inputParam_SetterSelectedElementToPanel={null}
                                                    inputParam_ShowToolbar={false}
                                                />
                                            </Col>
                                        )
                                    }
                                    </Row>
                                </div>
                            </Row>
                        </Col>
                    }
                    <Col className='me-3'>
                        <Row className='p-0'>
                            <Col className='mx-0 pb-2 px-1 mx-auto'>
                                {
                                    consolidatedGroupChart &&
                                    <ChartLine inputParam_Width={200} inputParam_ChartData={consolidatedGroupChart}/>
                                }
                            </Col>
                        </Row>
                    </Col>
                </Row>                                
                    
    }

    return (
        <>
            { generateDom() }
        </>
    );
}

SG3KPI_CONSOLIDATE_MONTH_DUMMY.propTypes = {
};

export default SG3KPI_CONSOLIDATE_MONTH_DUMMY;